import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ErrorBoundary from './ErrorBoundary';

export default function Layout({ openEnquiry }) {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div>
      <Navbar openEnquiry={openEnquiry} />
      {!isHome && <div style={{ height: 96 }} />}
      <main>
        <ErrorBoundary>
          <Outlet context={{ openEnquiry }} />
        </ErrorBoundary>
      </main>
      <Footer openEnquiry={openEnquiry} />
    </div>
  );
}
